import React from 'react';
import ReactMapboxGl, { Layer, Feature, Popup } from 'react-mapbox-gl';
import styled from 'styled-components';
import 'mapbox-gl/dist/mapbox-gl.css';
import markerPin from './img/pin.png';
import { getLocations } from './util';

let markerPinImage = new Image();
markerPinImage.src = markerPin;
markerPinImage.width = 48;
markerPinImage.height = 64;

let markerPinImageSmall = new Image();
markerPinImageSmall.src = markerPin;
markerPinImageSmall.width = 36;
markerPinImageSmall.height = 48;

let markerImages = ['pin', markerPinImage];
let markerImagesSmall = ['smallpin', markerPinImageSmall];

let startCenter = [16.70214, 44.75974];

function calcBounds(data, margin = 0.1, loc = (d) => d.location) {
  if (data.length === 0) return undefined;
  let min = [loc(data[0])[0], loc(data[0])[1]],
    max = min;
  data.forEach((d) => {
    let l = loc(d);
    min = [Math.min(min[0], l[0]), Math.min(min[1], l[1])];
    max = [Math.max(max[0], l[0]), Math.max(max[1], l[1])];
  });
  let d = [(max[0] - min[0]) * margin, (max[1] - min[1]) * margin];
  return [
    [min[0] - d[0], min[1] - d[1]],
    [max[0] + d[0], max[1] + d[1]],
  ];
}

let Map = ReactMapboxGl({
  minZoom: 7,
  maxZoom: 16,
  accessToken:
    'pk.eyJ1Ijoic3RldmVzY2hhcnBpcm8iLCJhIjoiY2s1NWNmYXg2MGYzdTNrbDhuZnpjZmVzbiJ9.cG_1CuNF6k9pvzWjCD-LcA',
});

export default function MyMap(props) {
  let { data, filter, setFilter, setLocation } = props;

  let [ hover, setHover ] = React.useState(null); // { location, name }
  let [ locationBounds, setLocationBounds ] = React.useState();

  let locations = getLocations(filter, data);

  React.useEffect(() => {
    let bounds = calcBounds(locations)
    setLocationBounds(bounds, 0.2);
    setTimeout(() => {
      let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      if (vw > 1000 && window.MAP) {
        window.MAP.fitBounds(bounds);
      }
    }, 1000);
  }, [data.length, filter]);

  return (
    <Wrap className={"mapbox-map " + (hover == null ? '' : 'hover')}>
    <Map
      style="mapbox://styles/mapbox/light-v9"
      onStyleLoad={(m) => (window.MAP = m)}
      center={startCenter}
      fitBounds={locationBounds}
      maxBounds={calcBounds(data, 0.3)}
      containerStyle={{
        height: '100%',
        width: '100%',
      }}
    >
    { hover && <Popup
        coordinates={hover.location}
        offset={{
          'bottom-left': [12, -38],  'bottom': [0, -30], 'bottom-right': [-12, -38]
        }}>
        <p style={{fontSize: '1.2em'}}>{ hover.name }</p>
      </Popup> }
      <Layer
        id="locations"
        minZoom={10}
        images={markerImagesSmall}
        layout={{ 'icon-image': 'smallpin', 'icon-allow-overlap': true }}
      >
        {locations.map(loc => {
          let { totem_id, name, location } = loc;
          return (
          <Feature key={totem_id} coordinates={location}
            onMouseEnter={() => { setHover({name, location}); setLocationBounds(null); }}
            onMouseLeave={() => setHover(null)}
            onClick={() => setLocation(loc)}
 />
        )})}
      </Layer>

      <Layer
        id="cities"
        maxZoom={10}
        images={markerImages}
        layout={{ 'icon-image': 'pin', 'icon-allow-overlap': true }}
      >
        {data.map(({ city_id, name, location }) => (
          <Feature key={city_id} coordinates={location}
            onMouseEnter={() => { setHover({name, location}); setLocationBounds(null); }}
            onMouseLeave={() => setHover(null)}
            onClick={() => setFilter({...filter, city: city_id})}/>
        ))}
      </Layer>
    </Map>
    </Wrap>
  );
}

let Wrap = styled.div`
  &.hover canvas {
    cursor: pointer;
  }
`;
